function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1"
}, React.createElement("g", {
  id: "Reporting"
}, React.createElement("g", {
  id: "User-Management-Icon"
}, React.createElement("g", {
  id: "noun_1723130_cc",
  "data-name": "noun 1723130 cc"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  id: "Shape",
  className: "cls-1",
  d: "M224.34,116.26a3.81,3.81,0,0,1-2.68-1.1l-67.12-66.5a3.74,3.74,0,0,1,0-5.32l18.36-18.2a3.82,3.82,0,0,1,5.37,0l67.12,66.5a3.74,3.74,0,0,1,0,5.32L227,115.16A3.81,3.81,0,0,1,224.34,116.26ZM162.59,46l61.75,61.18,13-12.88L175.59,33.12Z"
}), React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  className: "cls-1",
  d: "M25.68,116.26a3.81,3.81,0,0,1-2.68-1.1L4.61,97a3.74,3.74,0,0,1,0-5.32l67.12-66.5a3.82,3.82,0,0,1,5.37,0L95.48,43.34A3.68,3.68,0,0,1,96.59,46a3.73,3.73,0,0,1-1.11,2.66l-67.11,66.5A3.83,3.83,0,0,1,25.68,116.26Zm-13-22,13,12.89L87.43,46l-13-12.89Z"
}), React.createElement("g", {
  id: "Shape-3",
  "data-name": "Shape"
}, React.createElement("path", {
  className: "cls-1",
  d: "M60.57,156.14A3.81,3.81,0,0,1,57,153.71l-16.1-42.55a3.76,3.76,0,0,1,2.22-4.85,3.81,3.81,0,0,1,4.89,2.2l16.11,42.55a3.76,3.76,0,0,1-2.22,4.85A3.94,3.94,0,0,1,60.57,156.14Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M125,76.35a3.53,3.53,0,0,1-.85-.1l-34.91-8a3.75,3.75,0,0,1-2.84-4.51A3.8,3.8,0,0,1,91,60.94l34.9,8a3.76,3.76,0,0,1-.85,7.43Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M184.07,178.08a15.13,15.13,0,0,1-10.74-4.41L170.65,171a3.71,3.71,0,0,1,0-5.31,3.8,3.8,0,0,1,5.37,0l2.68,2.66a7.83,7.83,0,0,0,10.74,0,7.48,7.48,0,0,0,0-10.64l-2.69-2.66a3.74,3.74,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l2.69,2.66a14.93,14.93,0,0,1,0,21.28A15.14,15.14,0,0,1,184.07,178.08Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M168,194h0a15.12,15.12,0,0,1-10.73-4.41L154.54,187a3.74,3.74,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l2.68,2.66a7.63,7.63,0,0,0,10.74,0,7.49,7.49,0,0,0,0-10.64L170.65,171a3.71,3.71,0,0,1,0-5.31,3.79,3.79,0,0,1,5.36,0l2.69,2.66a15,15,0,0,1,0,21.27A15.13,15.13,0,0,1,168,194Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M151.85,210a15.19,15.19,0,0,1-10.73-4.39l-2.69-2.66a3.72,3.72,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l2.68,2.66a7.68,7.68,0,0,0,10.75,0,7.51,7.51,0,0,0,0-10.65L154.54,187a3.74,3.74,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l2.68,2.66a15,15,0,0,1,0,21.28A15.26,15.26,0,0,1,151.85,210Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M135.75,226a15.23,15.23,0,0,1-10.74-4.4l-2.69-2.66a3.74,3.74,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l2.69,2.66a7.65,7.65,0,0,0,10.73,0,7.47,7.47,0,0,0,0-10.64l-2.69-2.66a3.72,3.72,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l2.68,2.66a14.95,14.95,0,0,1,0,21.28A15.2,15.2,0,0,1,135.75,226Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M39.1,118.92a3.82,3.82,0,0,1-2.69-1.1,3.74,3.74,0,0,1,0-5.32L92.78,56.63a3.82,3.82,0,0,1,5.37,0,3.72,3.72,0,0,1,0,5.32L41.78,117.82A3.81,3.81,0,0,1,39.1,118.92Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M95.47,63.05A3.82,3.82,0,0,1,92.78,62l-8-8a3.74,3.74,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l8.05,8a3.72,3.72,0,0,1,0,5.32A3.81,3.81,0,0,1,95.47,63.05Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M39.1,118.92a3.82,3.82,0,0,1-2.69-1.1l-8-8a3.74,3.74,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l8.05,8a3.74,3.74,0,0,1,0,5.32A3.81,3.81,0,0,1,39.1,118.92Z"
})), React.createElement("g", {
  id: "Shape-4",
  "data-name": "Shape"
}, React.createElement("path", {
  className: "cls-1",
  d: "M189.44,156.16a3.85,3.85,0,0,1-1.33-.24,3.75,3.75,0,0,1-2.23-4.84L202,108.52a3.8,3.8,0,0,1,4.88-2.2,3.75,3.75,0,0,1,2.23,4.84L193,153.72A3.79,3.79,0,0,1,189.44,156.16Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M125,76.35a3.76,3.76,0,0,1-.85-7.42l34.9-8a3.76,3.76,0,1,1,1.71,7.33l-34.9,8A3.65,3.65,0,0,1,125,76.35Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M95.48,105.62a3.81,3.81,0,0,1-2.68-1.1,3.72,3.72,0,0,1,0-5.32l29.52-29.26a3.8,3.8,0,0,1,5.37,0,3.71,3.71,0,0,1,0,5.31L98.17,104.52A3.85,3.85,0,0,1,95.48,105.62Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M111.59,121.58a3.82,3.82,0,0,1-2.69-1.1,3.74,3.74,0,0,1,0-5.32L125,99.2a3.82,3.82,0,0,1,5.37,0,3.74,3.74,0,0,1,0,5.32l-16.11,16A3.81,3.81,0,0,1,111.59,121.58Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M138.43,105.62a3.83,3.83,0,0,1-2.69-1.1,3.81,3.81,0,0,0-5.36,0,3.82,3.82,0,0,1-5.37,0,3.72,3.72,0,0,1,0-5.32,11.47,11.47,0,0,1,16.1,0,3.72,3.72,0,0,1,0,5.32A3.81,3.81,0,0,1,138.43,105.62Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M189.44,156.16a3.83,3.83,0,0,1-2.69-1.1l-51-50.54a3.74,3.74,0,0,1,0-5.32,3.82,3.82,0,0,1,5.37,0l51,50.54a3.72,3.72,0,0,1,0,5.32A3.81,3.81,0,0,1,189.44,156.16Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M103.53,124.88a15.22,15.22,0,0,1-10.73-4.4,15,15,0,0,1,0-21.28,3.82,3.82,0,0,1,5.37,0,3.74,3.74,0,0,1,0,5.32,7.48,7.48,0,0,0,0,10.64,7.65,7.65,0,0,0,10.73,0,3.82,3.82,0,0,1,5.37,0,3.72,3.72,0,0,1,0,5.32A15.23,15.23,0,0,1,103.53,124.88Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M65.94,178.09a15.13,15.13,0,0,1-10.74-4.41,15,15,0,0,1,0-21.27l2.69-2.66a15.64,15.64,0,0,1,21.47,0,15,15,0,0,1,0,21.27l-2.69,2.66A15.09,15.09,0,0,1,65.94,178.09Zm2.68-25.23a7.59,7.59,0,0,0-5.37,2.2l-2.68,2.66a7.48,7.48,0,0,0,0,10.64,7.81,7.81,0,0,0,10.74,0L74,165.7a7.48,7.48,0,0,0,0-10.64A7.57,7.57,0,0,0,68.62,152.86Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M82.05,194.05a15.19,15.19,0,0,1-10.74-4.41,15,15,0,0,1,0-21.28L74,165.7a15.67,15.67,0,0,1,21.48,0,15,15,0,0,1,0,21.28l-2.68,2.66A15.19,15.19,0,0,1,82.05,194.05Zm2.68-25.23a7.61,7.61,0,0,0-5.37,2.2l-2.68,2.66a7.48,7.48,0,0,0,0,10.64,7.83,7.83,0,0,0,10.74,0l2.69-2.66a7.5,7.5,0,0,0,0-10.64A7.61,7.61,0,0,0,84.73,168.82Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M98.15,210a15.06,15.06,0,0,1-10.73-25.7l2.69-2.66a15.66,15.66,0,0,1,21.47,0,15,15,0,0,1,0,21.29l-2.68,2.66A15.21,15.21,0,0,1,98.15,210Zm2.69-25.24a7.61,7.61,0,0,0-5.37,2.2l-2.68,2.66a7.5,7.5,0,0,0,0,10.65,7.83,7.83,0,0,0,10.74,0l2.68-2.66a7.53,7.53,0,0,0-5.37-12.85Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M114.26,226a15.15,15.15,0,0,1-10.73-4.4,15,15,0,0,1,0-21.28l2.68-2.66a15.64,15.64,0,0,1,21.47,0,15,15,0,0,1,0,21.28L125,221.57A15.16,15.16,0,0,1,114.26,226ZM117,200.74a7.58,7.58,0,0,0-5.37,2.21l-2.68,2.66a7.48,7.48,0,0,0,0,10.64,7.82,7.82,0,0,0,10.73,0l2.69-2.66a7.5,7.5,0,0,0,0-10.64A7.62,7.62,0,0,0,117,200.74Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M210.91,118.92a3.81,3.81,0,0,1-2.68-1.1L151.86,62a3.72,3.72,0,0,1,0-5.32,3.81,3.81,0,0,1,5.36,0L213.6,112.5a3.74,3.74,0,0,1,0,5.32A3.83,3.83,0,0,1,210.91,118.92Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M154.54,63.06a3.81,3.81,0,0,1-2.68-1.1,3.72,3.72,0,0,1,0-5.32l8-8a3.8,3.8,0,0,1,5.37,0,3.73,3.73,0,0,1,0,5.31l-8.06,8A3.77,3.77,0,0,1,154.54,63.06Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M210.91,118.92a3.81,3.81,0,0,1-2.68-1.1,3.72,3.72,0,0,1,0-5.32l8.05-8a3.82,3.82,0,0,1,5.37,0,3.74,3.74,0,0,1,0,5.32l-8.05,8A3.83,3.83,0,0,1,210.91,118.92Z"
})))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 250 250"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/icon-customers.ee5638e0.svg";
export { SvgComponent as ReactComponent };